var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v("\n  "+_vm._s(_vm.hijriDate)+"\n  "),_c('span',{staticStyle:{"font-size":"smaller","color":"#435363"}},[_vm._v(" ("+_vm._s(_vm.miladiDate)+") ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }